"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var tools_1 = require("../utils/tools");
var NAME = 'bold';
function toggleMarkBold(editor) {
    var format = editor.getFormat();
    var status = !Boolean(format.bold);
    editor.setFormat({ bold: status });
    return true;
}
var Bold = /** @class */ (function (_super) {
    __extends(Bold, _super);
    function Bold() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'strong'; };
        _this.textMatcher = [
            {
                matcher: /\*\*([^*]+)\*\*\s$/
            }
        ];
        _this.parseDOM = [
            { tag: 'strong', priority: 25 },
            {
                tag: 'b',
                priority: 25,
                getAttrs: function (node) {
                    return node.style.fontWeight !== 'normal';
                }
            },
            /**
             * if h1 use font-weight to bolden content, it will marked as bold
             * mark cannot replaced as block when it has block node and marks
             * it will traverse it's content and insert it to paragraph
             * instead of replacing block
             */
            {
                style: 'font-weight',
                getAttrs: function (value) {
                    return /^bold(er)?$/.test(value) || +value >= 700;
                }
            }
        ];
        return _this;
    }
    Bold.keymap = {
        'Mod-b': toggleMarkBold,
        'Mod-B': toggleMarkBold
    };
    return Bold;
}(core_utilities_1.Inline));
exports.Bold = Bold;
var BoldController = /** @class */ (function (_super) {
    __extends(BoldController, _super);
    function BoldController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'bold',
            tooltip: 'bold'
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        return _this;
    }
    return BoldController;
}(core_utilities_1.SylController));
exports.BoldController = BoldController;
var BoldPlugin = /** @class */ (function (_super) {
    __extends(BoldPlugin, _super);
    function BoldPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = BoldController;
        _this.Schema = Bold;
        return _this;
    }
    return BoldPlugin;
}(core_utilities_1.SylPlugin));
exports.BoldPlugin = BoldPlugin;
//# sourceMappingURL=bold.js.map